import React, { lazy, Suspense } from 'react';
import ErrorBoundary from 'containers/ErrorBoundary';

const RiskShieldModule = lazy(() => import(
    /* webpackChunkName: "RiskShieldWebApp_RiskShield" */
    /* webpackPrefetch: true */
    // eslint-disable-next-line import/no-unresolved
    'RiskShieldWebApp/RiskShield'));

const RiskShield = () => (
  <ErrorBoundary fallback={<></>}>
    <Suspense fallback={<></>}>
      <RiskShieldModule basePath="risk-shield" product="PG" />
    </Suspense>
  </ErrorBoundary>
);

export default RiskShield;
